import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./Pages/Home";
import Insurance from "./Pages/Insurance";
import Companies from "./Pages/Companies/index.js";
import CompaniesManage from "./Pages/CompaniesManage";
import CompaniesAdd from "./Pages/CompaniesAdd";
import CompaniesEdit from "./Pages/CompaniesEdit";
import Users from "./Pages/Users";
import Providers from "./Pages/Providers";
import Strategies from "./Pages/Strategies";
import SubmittedBusiness from "./Pages/SubmittedBusiness";
import StatementsIn from "./Pages/StatementsIn";
import StatementsInSummary from "./Pages/StatementsInSummary";
import Login from "./Pages/Login";
import Compliance from "./Pages/Compliance";
import Matching from "./Pages/Matching";
import Helpers from "./Pages/Helpers";
import MainProviders from "./Pages/MainProviders";
import Matched from "./Pages/Matched";
import AdvisorStatementsList from "./Pages/AdvisorStatementsList";
import AdvisorStatements from "./Pages/AdvisorStatements";
import Consolidator from "./Pages/Consolidator";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Auth0Provider } from '@auth0/auth0-react';


const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/new-record",
    element: <Home />,
  },
  {
    path: "/insurance",
    element: <Insurance />,
  },
  {
    path: "/submitted",
    element: <SubmittedBusiness />,
  },
  {
    path: "/statements-in/:summaryID",
    element: <StatementsIn />,
  },
  {
    path: "/statements-in/summary",
    element: <StatementsInSummary />,
  },
  {
    path: "/companies",
    element: <Companies />,
  },
  {
    path: "/companies/add",
    element: <CompaniesAdd />,
  },
  {
    path: "/companies/edit/:companyID",
    element: <CompaniesEdit />,
  },
  {
    path: "/users",
    element: <Users />,
  },
  {
    path: "/providers",
    element: <Providers />,
  },
  {
    path: "/strategies",
    element: <Strategies />,
  },
  {
    path: "/compliance",
    element: <Compliance />,
  },
  {
    path: "/matching",
    element: <Matching />,
  },
  {
    path: "/matched/:summaryID/:statementID",
    element: <Matched />,
  },
  {
    path: "/consolidator",
    element: <Consolidator />,
  },
  {
    path: "/advisor-statement",
    element: <AdvisorStatements />,
  },
  {
    path: "/advisor-statements",
    element: <AdvisorStatementsList />,
  },
  {
    path: "/helpers",
    element: <Helpers />,
  },
  {
    path: "/main-providers",
    element: <MainProviders />,
  },
]);

const queryClient = new QueryClient();

const auth0Domain =
  process.env.REACT_APP_AUTH0_DOMAIN || process.env.VITE_AUTH0_DOMAIN;
const auth0ClientId =
  process.env.REACT_APP_AUTH0_CLIENT_ID || process.env.VITE_AUTH0_CLIENT_ID;

const onAuth0RedirectCallback = (appState) => {
  const returnTo = appState?.returnTo || "/new-record";
  window.location.href = returnTo;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  auth0Domain && auth0ClientId ? (
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin
      }}
      onRedirectCallback={onAuth0RedirectCallback}
    >
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </Auth0Provider>
  ) : (
    <React.StrictMode>
      <div style={{ padding: 24, fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif" }}>
        <h2 style={{ margin: 0, marginBottom: 12 }}>Missing Auth0 environment variables</h2>
        <p style={{ margin: 0, marginBottom: 12 }}>
          Set <code>REACT_APP_AUTH0_DOMAIN</code> and <code>REACT_APP_AUTH0_CLIENT_ID</code> in <code>.env</code>, then restart the dev server.
        </p>
      </div>
    </React.StrictMode>
  )

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
